import React from 'react';
import Header from '../components/Header';
import Hero from '../components/Hero';
import Services from '../components/Services';
import PermanentLightingSection from '../components/PermanentLightingSection';
import Gallery from '../components/Gallery';
import TreeWrapping from '../components/TreeWrapping';
import DIYSection from '../components/DIYSection';
import PricingSection from '../components/PricingSection';
import CustomerJourney from '../components/CustomerJourney';
import QuoteForm from '../components/QuoteForm';
import Footer from '../components/Footer';

const LandingPage = () => {
  return (
    <div className="landing-page">
      <Header />
      <Hero />
      <Services />
      <PermanentLightingSection />
      <Gallery />
      <TreeWrapping />
      <DIYSection />
      <PricingSection />
      <CustomerJourney />
      <QuoteForm />
      <Footer />
    </div>
  );
};

export default LandingPage;
